import {useEffect, useState} from "react";

const useElementVisibility = (ref) => {
  const [isOutsideViewport, setIsOutsideViewport] = useState(false);

  useEffect(() => {
    const checkIfOutsideViewport = () => {
      const el = ref.current;
      if (!el || !window.visualViewport) return;

      const rect = el.getBoundingClientRect();
      const vp = window.visualViewport;

      setIsOutsideViewport(
        rect.right < vp.offsetLeft ||
        rect.bottom < vp.offsetTop ||
        rect.left > vp.offsetLeft + vp.width ||
        rect.top > vp.offsetTop + vp.height,
      );
    };

    checkIfOutsideViewport();

    window.visualViewport?.addEventListener("resize", checkIfOutsideViewport);
    window.visualViewport?.addEventListener("scroll", checkIfOutsideViewport);

    return () => {
      window.visualViewport?.removeEventListener(
        "resize",
        checkIfOutsideViewport,
      );
      window.visualViewport?.removeEventListener(
        "scroll",
        checkIfOutsideViewport,
      );
    };
  }, []);

  return { isOutsideViewport };
};

export default useElementVisibility;